<template>
    <app-layout content_class="content-section has-background-light">
        <h1 class="title is-pulled-left">Member Spaces</h1>
        <user-avatar class="is-pulled-right"/>
        <div class="is-clearfix"></div><br/>

        <space-list/><br/><br/>
        <space-available-list/>
    </app-layout>
</template>

<script>
import { set_title } from '../utils/helpers';
import SpaceList from '../components/space/SpaceList.vue';
import AppLayout from '../components/layouts/AppLayout.vue';
import UserAvatar from '../components/user/UserAvatar.vue';
import SpaceAvailableList from '../components/space/SpaceAvailableList.vue';

export default {
    name: 'Spaces',
    components: {
        SpaceAvailableList, UserAvatar, SpaceList, AppLayout,
    },
    created() {
        set_title('Spaces list');
    },
};
</script>
